import styled from 'styled-components';
import { loaderAnimationStyles } from '@dealstack/frontend/shared/components/loaders/shared/loaderAnimation.styles';

export const InlineLoaderAnimationStyles = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 6rem;
	height: 6rem;

	svg {
		width: 100%;
		height: 100%;
		display: block;
	}

	${loaderAnimationStyles}
`;
